import { QUICK_LAUNCH_ASSET_TYPES } from './constants';
import type { AssetQuickLaunchPrefill } from './types';

const extractTypeRegex = /\/editorial\/create\/([^/]+)\/?/i;

export const normalizeAssetType = (value: string | null | undefined): string => {
  return (value || '').trim().toLowerCase();
};

export const extractAssetTypeFromPath = (path: string | undefined): string | null => {
  if (!path) {
    return null;
  }

  const match = path.match(extractTypeRegex);
  if (!match || !match[1]) {
    return null;
  }

  return normalizeAssetType(match[1]);
};

export const isQuickLaunchAssetType = (assetType: string | null | undefined): boolean => {
  if (!assetType) {
    return false;
  }

  return QUICK_LAUNCH_ASSET_TYPES.has(normalizeAssetType(assetType));
};

export const buildQuickLaunchPrefillFromRecord = (
  record: any,
): AssetQuickLaunchPrefill => {
  if (!record) {
    return {};
  }

  const workflowRaw = record?.properties?.workflow_id ?? record?.workflow_id;
  const startTimeRaw = record?.start_time ?? record?.properties?.start_time;
  const slugRaw =
    record?.properties?.print_slug ?? record?.print_slug ?? record?.slug;

  const workflowId =
    typeof workflowRaw === 'string' ? workflowRaw.trim() : workflowRaw ?? null;

  const startTime =
    typeof startTimeRaw === 'string' && startTimeRaw.trim().length === 0
      ? null
      : startTimeRaw ?? null;

  const slug =
    typeof slugRaw === 'string' && slugRaw.trim().length > 0
      ? slugRaw.trim()
      : undefined;

  const prefill: AssetQuickLaunchPrefill = {};

  if (workflowId !== undefined) {
    prefill.workflowId = workflowId || null;
  }

  if (startTimeRaw !== undefined) {
    prefill.startTime = startTime;
  }

  if (slug !== undefined) {
    prefill.slug = slug;
  }

  return prefill;
};

export const mergeQuickLaunchPrefill = (
  defaults?: AssetQuickLaunchPrefill,
  overrides?: AssetQuickLaunchPrefill,
): AssetQuickLaunchPrefill | undefined => {
  if (!defaults && !overrides) {
    return undefined;
  }

  const merged: AssetQuickLaunchPrefill = {
    ...(defaults || {}),
    ...(overrides || {}),
  };

  return Object.keys(merged).length ? merged : undefined;
};
